import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import CreateDialog from '../components/layout/CreateDialog';

const CreateDialogDemo = () => {
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelectOption = (option) => {
    setSelectedOption(option);
    handleClose();
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 4 }}>Create Dialog Demo</Typography>
      
      <Button 
        variant="contained" 
        onClick={handleOpen}
        sx={{ mb: 3 }}
      >
        Open Create Dialog
      </Button>
      
      {selectedOption && (
        <Typography variant="body1">
          You selected: <strong>{selectedOption}</strong>
        </Typography>
      )}
      
      <CreateDialog 
        open={open} 
        onClose={handleClose}
        onSelectOption={handleSelectOption}
      />
    </Box>
  );
};

export default CreateDialogDemo;